export default "__VITE_ASSET__BtvGgLg$__"